import React from "react";
import { Card } from "semantic-ui-react";
import ScrapeBookDetails from "./ScrapBookDetails";
import { archiveList } from "../archive";

// const colors = [
//   "red",
//   "orange",
//   "yellow",
//   "olive",
//   "green",
//   "teal",
//   "blue",
//   "violet",
//   "purple",
//   "pink",
//   "brown",
//   "grey"
// ];

class ScrapeBook extends React.Component {
  shouldComponentUpdate(nextProps) {
    return false;
  }
  render() {
    return (
      <Card.Group>
        {archiveList.map((archive, i) => (
          <ScrapeBookDetails {...archive} key={i} />
        ))}
      </Card.Group>
    );
  }
}

export default ScrapeBook;



// WEBPACK FOOTER //
// ./src/components/ScrapeBook.js